import { get } from 'object-path';

export function getPrintMeta(item: any): any {
  return get(item, 'meta.andalways:print.options', null);
}
